import { css } from '@emotion/css';
import { DesignToken, RadiusToken, ShadowToken, SpacingToken } from '@livechat/design-system-react-components';

export const sampleChatBubbleTourStep = css`
  && {
    left: 40%;
    [class^='lc-light-theme lc-UserGuideBubbleStep-module__user-guide-bubble-step'] {
      width: 380px;
    }
  }
`;

export const tourStepStylesBase = css`
  border-radius: var(${RadiusToken.Radius3});
  box-shadow: var(${ShadowToken.ShadowAiCopilotAnimationMedium2}) !important;
`;

export const chatsListStepStyles = css`
  ${tourStepStylesBase}
  background-color: var(${DesignToken.SurfacePrimaryDefault}) !important;
  div {
    border-bottom: none;
  }
`;

export const tourStepStylesWithRadius = css`
  ${tourStepStylesBase}
  div {
    border-radius: var(${RadiusToken.Radius3});
  }
  [class*='lc-Avatar-module__avatar--circle'] {
    border-radius: 50%;
  }
  [class*='lc-Avatar-module__avatar--rounded-square'] {
    border-radius: var(${RadiusToken.Radius1});
  }
`;

export const replySuggestionsStepStyles = css`
  ${tourStepStylesBase}
  background-color: var(${DesignToken.SurfacePrimaryDefault}) !important;
  border-color: var(${DesignToken.ActionPrimaryDefault}) !important;
`;

export const tagsStepStyles = css`
  ${tourStepStylesBase}
  padding: var(${SpacingToken.Spacing1}) !important;
  background-color: var(${DesignToken.SurfacePrimaryDefault}) !important;
`;
